import {useState, useEffect} from "react";
import APICallService from "../api/apiCallService";
import {termsAndConditions as termsAndConditionsEndpoint} from "../api/apiEndPoints";
import Loader from "../Global/loader";

const TermsAndConditions = () => {
    const [termsAndConditionsData, setTermsAndConditionsData] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchTermsAndConditions = async () => {
            try {
                setLoading(true);
                const apiService = new APICallService(termsAndConditionsEndpoint, {});
                const response = await apiService.callAPI();

                if (response) {
                    let parsedResponse = response;
                    if (typeof response === "string") {
                        try {
                            parsedResponse = JSON.parse(response);
                        } catch (e) {
                            return;
                        }
                    }

                    if (parsedResponse.data) {
                        setTermsAndConditionsData(parsedResponse.data);
                    }
                }
            } catch (error) {
                // Error handling
            } finally {
                setLoading(false);
            }
        };

        fetchTermsAndConditions();
    }, []);

    return (
        <>
            <div className="main-hero-sec wrapper overflow-hidden">
                <div className="container py-5 py-md-5">
                    <div className="row align-items-center gy-5">
                        <div className="col-lg-12 text-center">
                            <h1 className="fs-50 fw-bolder mb-5 main-ease-animator1">Terms & Conditions</h1>
                        </div>
                    </div>
                </div>
            </div>

            <div className="wrapper pb-8 pb-lg-10">
                <div className="container">
                    {loading ? (
                        <div className="text-center p-4">
                            <Loader loading={loading} />
                        </div>
                    ) : termsAndConditionsData ? (
                        <div className="fs-18 fw-medium" dangerouslySetInnerHTML={{__html: termsAndConditionsData}} />
                    ) : (
                        <p className="fs-18 fw-medium">No terms and conditions data available.</p>
                    )}
                </div>
            </div>
        </>
    );
};

export default TermsAndConditions;
